<template>
  <main>
    <account-list v-if="!isProfileView" :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" :accountType="shippers" :handling="true" :children="true"/>
    <div class="app-view-container">
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col
        v-if="isnternal()"
        class="app-view-title">
          {{ $t('daysOfService.shipperDaysOfServiceTitle') }}
        </el-col>
        <el-col v-else class="app-view-title">
            {{ $t('daysOfService.DaysOfServiceTitleView') }}
        </el-col>
        <el-col :span="12" class="align-right">
          <name-badge
              v-if="accountNameNumber"
              :account-name="accountNameNumber"
              :is-active="accountActive"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>
      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="8" class="default-section-title">
              {{ $t('daysOfService.summary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="16" class="default-section-actions text-align-end">
              <download-csv/>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import constants from '@/utils/constants';
import NameBadge from '@/views/customerCenter/customerMasterRecord/components/nameBadge/NameBadge';
import AccountList from '@/components/AccountList';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import DownloadCsv from '../components/DownloadCsv';

export default {
  name: 'DaysOfService',
  props: {
    accountNameNumber: {
      type: String,
      required: false
    },
    accountActive: {
      type: Boolean,
      required: false
    }
  },
  components: {
    NameBadge,
    SearchFilter,
    SearchSummary,
    AccountList,
    DownloadCsv
  },
  data() {
    return {
      daysOfWeekSelected: [],
      actionMountChained: ['daysOfService/setDefaultFilters'],
      actionSelectChained: ['daysOfService/search'],
      shippers: constants.ACCOUNTS.TYPE[1].value
    };
  },
  computed: {
    daysOfWeek() {
      return constants.DAY_OF_SERVICE.DAYS_OF_WEEK;
    },
    isProfileView() {
      return this.$route.path.includes('armelliniProfile');
    }
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    },
    isnternal() {
      return this.$store.getters.user.permissions.includes(this.permissions.MENU_VIEWS.MANAGE_DAY_OF_SERVICE_VIEW);
    },

  }
};
</script>
<style scoped>
.align-right {
  justify-content: flex-end; /* Fuerza el contenido al extremo derecho */
  text-align: right;        /* Backup para navegadores antiguos [cite: 17] */
}
</style>
